import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";
// =============================== BASE  ===============================  //
const app = getApp();

export const REF = {
  NAME: "finance",
  COLLECTIONS: {
    RESELLER: "reseller",
    LIFE: "life",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    reseller: collection(firestore, REF.COLLECTIONS.RESELLER),
    life: collection(firestore, REF.COLLECTIONS.LIFE),
  };
  return CREF;
};
